export default "__VITE_ASSET__DDH0$1tK__"